var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"type":"card-full"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.ptc.ptctext)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }